import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import Download from '@mui/icons-material/SimCardDownload';

export default function DocCard({ title, href }) {

    return (

        <Link to={href}>
            <Paper sx={{ m: '35px', p: '30px',  textAlign: 'center'}}>
                <Typography sx={{ mb: '35px' }} gutterBottom variant="body1" centered component="div">
                    {title}
                </Typography>
                <Download sx={{ fontSize: '100px', color: '#5281B5'}}></Download>
            </Paper>
        </Link>

    );
}